// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import buttonSizeVariants from "@tps/MobiusOverrides/Button/buttonSizeVariants";
import IconPaginationArrowLeftDarkInactive from "@tps/XDL/Icons/IconPaginationArrowLeftDarkInactive";
import IconPaginationArrowRightDarkInactive from "@tps/XDL/Icons/IconPaginationArrowRightDarkInactive";
import { xBaseTheme } from "@tps/XDL/types";
import { color, xScreen } from "@tps/XDL/Utilities";
import { mergeWithCss } from "@tps/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            sizeVariant: "small",
            cssOverrides: {
                formField: css`
                    width: unset;
                    padding-right: 0;
                `,
                formInputWrapper: css`
                    max-width: 75px;
                `,
            },
            labelProps: {
                size: 14,
                weight: "normal",
                css: css`
                    letter-spacing: 0;
                    line-height: 22px;
                    padding: 3px 8px 0 0;
                `,
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: IconPaginationArrowLeftDarkInactive,
            nextPage: IconPaginationArrowRightDarkInactive,
            lastPage: "ChevronsRight",
        },

        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
            css: css`
                min-height: ${buttonSizeVariants["small"].height}px;
                border: none;
                ${IconWrapper} {
                    color: ${color("text.main")};
                }
                &:disabled {
                    ${IconWrapper} {
                        opacity: 0.33;
                    }
                }
                &:hover:not(:disabled) {
                    border: none;
                    color: ${color("common.ui1")};
                    ${IconWrapper} svg path {
                        fill: ${color("common.ui8")};
                    }
                }
            `,
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
                linkList: css`
                    & > ul {
                        display: flex;
                        align-items: center;
                    }
                    /* XNG-Changes: fixed pagination to be one line on tablet and mobile */
                    ${xScreen("lte", "md")} {
                        width: auto;
                    }
                `,
                perPageSelect: css`
                    display: inherit;
                    ${xScreen("lte", "md")} {
                        width: auto;
                    }
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
